/** @jsxImportSource react/jsx-runtime */
/** @jsxRuntime classic */

import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import moment from "moment";
import logo from "../../assests/authLogo.png";
import localizedStrings from "../../utils/localize";
import { paymentOptionList } from "../../utils/general";

// Create styles
const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    flexWrap: "wrap",
    width: "100%",
  },
  container1: {
    flexWrap: "wrap",
    width: "100%",
  },
  cellfooter: {
    width: "100%",
  },
  cell: {
    width: "48%",
    borderWidth: 1,
    borderColor: "#000",
    padding: 5,
  },
  cell2: {
    width: "12%",
    borderWidth: 1,
    borderColor: "#000",
    padding: 4,
  },
  cell7: {
    width: "20%",
    borderWidth: 1,
    borderColor: "#000",
    padding: 4,
  },
  cell3: {
    width: "15%",
    borderWidth: 1,
    borderColor: "#000",
    padding: 4,
  },
  cell4: {
    width: "25%",
    borderWidth: 1,
    borderColor: "#000",
    padding: 4,
  },
  cell8: {
    width: "32%",
    borderWidth: 1,
    borderColor: "#000",
    padding: 4,
  },
  cell5: {
    width: "45%",
    borderWidth: 1,
    borderColor: "#000",
    padding: 5,
  },
  cell6: {
    width: "30%",
    borderWidth: 1,
    borderColor: "#000",
    padding: 5,
  },
  tc: {
    textAlign: "center",
  },
  tr: {
    textAlign: "right",
  },
  headerCell: {
    fontWeight: "bold",
  },
  headText: {
    margin: 4,
  },
  page: {
    flexDirection: "column",
    alignItems: "stretch",
    backgroundColor: "#fff",
    padding: 30,
    margin: 12,
    marginRight: 10,
  },
  row: {
    flexDirection: "row",
    flexWrap: "wrap",
    marginBottom: 10,
  },
  col: {
    width: "50%",
  },
  col2: {
    width: "100%",
  },
  section: {
    fontSize: 10,
  },
  imgstyle: {
    width: "50%",
  },
  textstyle: {
    color: "#032037d4",
    fontSize: 12,
  },
  font2: {
    fontSize: 10,
    fontWeight: "bold",
  },
  color1: {
    backgroundColor: "#003e6a",
    color: "white",
  },
  textstyle1: {
    color: "#350466",
    fontSize: 15,
    fontWeight: "bold",
    margingLeft: 12,
  },
  section2: {
    backgroundColor: "#003e6a",
    color: "white",
    fontSize: 13,
    fontWeight: "bold",
    padding: 5,
  },
  section3: {
    backgroundColor: "#003e6a",
    color: "white",
    fontSize: 8,
    fontWeight: "bold",
    padding: 5,
  },
  sectiongeneral: {
    backgroundColor: "#1aa1d642",
    color: "white",
    fontSize: 13,
    fontWeight: "bold",
    padding: 5,
  },
  mt: { marginTop: -5 },
  mt1: { marginTop: 0 },
  mt2: { marginTop: 10 },
  mb: { marginBottom: 6 },
  mb1: { marginBottom: 0 },
  mb2: { marginBottom: 20 },
  ml: { marginLeft: 6 },
  mr: { marginRight: 6 },
  tl: { textAlign: "left" },
  textBold: {
    fontWeight: 500,
    fontSize: 12,
    color: "black",
  },
  ht: {
    height: "26%",
    maxHeight: "26%",
  },
});

function convertCurrencyFormat(inputAmount) {
  // Check if the inputAmount is a valid number
  if (typeof inputAmount !== "number" || isNaN(inputAmount)) {
    return "Invalid input amount";
  }
  // Determine if the inputAmount is negative
  const isNegative = inputAmount < 0;

  // Convert the absolute value of the numeric amount into the desired format
  const formattedAmount = Math.abs(inputAmount).toFixed(2);

  // Replace the decimal separator (dot) with a comma
  // and the thousands separator (comma) with a space
  let result = `${formattedAmount
    .replace(".", ",")
    .replace(/\B(?=(\d{3})+(?!\d))/g, " ")} $`;

  // Add parentheses for negative amounts
  if (isNegative) {
    result = `(${result})`;
  }

  return result;
}

function totalSumAmount(data, param) {
  let sumofTotalAmount = data.reduce(
    (total, currentValue) => (total = total + currentValue[param]),
    0,
  );

  return convertCurrencyFormat(sumofTotalAmount);
}
function subtractValues(data1, data2) {
  let value1 = data1.reduce(
    (total, currentValue) => (total = total + currentValue["totalamount"]),
    0,
  );
  let value2 = data2.reduce(
    (total, currentValue) => (total = total + currentValue["ses_paymentamt"]),
    0,
  );
  let finalValue = value1 - value2;
  return convertCurrencyFormat(finalValue);
}

// Create Document Component
const ARReport = ({ data }) => {
  const language = "fr";

  localizedStrings.setLanguage(language);
  return (
    <Document>
      {Object.keys(data).length !== 0 && (
        <Page size="A4" style={styles.page}>
          <View style={[styles.row]}>
            <View style={styles.col}>
              <View style={styles.section}>
                <Image src={logo} style={styles.imgstyle} />
              </View>
              <View style={[styles.section]}>
                <Text style={styles.textstyle}>
                  200, avenue de la Cathédrale{" "}
                </Text>
              </View>
              <View style={[styles.section]}>
                {" "}
                <Text style={styles.textstyle}>
                  Winnipeg (Manitoba) R2H 0H7
                </Text>
              </View>

              <View style={[styles.section]}>
                {" "}
                <Text style={styles.textstyle}>1-204-233-0210</Text>
              </View>
              <View style={[styles.section]}>
                {" "}
                <Text style={styles.textstyle}>
                  Numéro d'entreprise : 106953110
                </Text>
              </View>
            </View>
            <View style={styles.col}>
              <View style={[styles.headerCell]}>
                <Text style={[styles.textstyle1, styles.ml]}>
                  Relevé de compte
                </Text>
              </View>
              <View style={[styles.headText, styles.font2]}>
                <View style={[styles.cell, styles.color1]}>
                  <Text>Date du rapport</Text>
                </View>
                <View style={[styles.cell]}>
                  <Text>{moment(new Date()).format("YYYY/MM/DD")}</Text>
                </View>
              </View>
            </View>
          </View>

          {/*second part  */}

          <View style={styles.row}>
            <View style={styles.col}>
              <View style={[styles.section, styles.sectiongeneral]}>
                <Text style={[styles.textBold]}>A:</Text>
              </View>
              <View style={styles.section}>
                <Text>{data.general.fullname}</Text>
              </View>
              <View style={styles.section}>
                <Text>{data.general.address1_composite}</Text>
              </View>
              <View style={styles.section}>
                <Text>{data.general.telephone1}</Text>
              </View>
              <View style={styles.section}>
                <Text>{data.general.emailaddress1}</Text>
              </View>
              <View style={styles.section}>
                <Text>{data.general.ses_student}</Text>
              </View>
            </View>
          </View>

          {/* third part */}

          <View style={styles.row}>
            <View>
              <Text style={[styles.textstyle1]}>Historique des factures</Text>
              <br /> <br />
            </View>

            <View
              style={[styles.container, styles.font2, styles.mb1, styles.mt2]}
            >
              <View style={[styles.cell3, styles.headerCell, styles.section3]}>
                <Text>DATE</Text>
              </View>
              <View
                style={[
                  styles.cell4,
                  styles.headerCell,
                  styles.section3,
                  styles.tc,
                ]}
              >
                <Text>SESSION</Text>
              </View>
              <View
                style={[
                  styles.cell5,
                  styles.headerCell,
                  styles.section3,
                  styles.tc,
                ]}
              >
                <Text>DESCRIPTION</Text>
              </View>
              <View
                style={[
                  styles.cell3,
                  styles.headerCell,
                  styles.section3,
                  styles.tc,
                ]}
              >
                <Text>MONTANT</Text>
              </View>

              {data &&
                data?.invoices &&
                data?.invoices?.map((ele, index) => (
                  <React.Fragment>
                    <View style={[styles.cell3, styles.tl]}>
                      <Text>
                        {moment(ele.ses_invoicedate).format("YYYY/MM/DD")}
                      </Text>
                    </View>
                    <View style={[styles.cell4, styles.tl]}>
                      <Text>
                        {
                          ele[
                            "_ses_term_value@OData.Community.Display.V1.FormattedValue"
                          ]
                        }
                      </Text>
                    </View>
                    <View style={[styles.cell5, styles.tl]}>
                      <Text>{ele.name}</Text>
                    </View>
                    <View style={[styles.cell3, styles.tr]}>
                      <Text>{convertCurrencyFormat(ele.totalamount)}</Text>
                    </View>
                  </React.Fragment>
                ))}

              <View style={[styles.cell3, , styles.tl]}>
                <Text>Total</Text>
              </View>
              <View style={[styles.cell4]}>
                <Text></Text>
              </View>
              <View style={[styles.cell5]}>
                <Text></Text>
              </View>

              <View style={[styles.cell3, styles.tr]}>
                <Text>{totalSumAmount(data.invoices, "totalamount")}</Text>
              </View>
            </View>
          </View>

          {/* fourth part */}

          <View style={styles.row}>
            <View>
              <Text style={[styles.textstyle1]}>Historique des paiements</Text>
              <br /> <br />
            </View>
            <View
              style={[styles.container, styles.font2, styles.mb1, styles.mt2]}
            >
              <View style={[styles.cell2, styles.headerCell, styles.section3]}>
                <Text>DATE</Text>
              </View>
              <View
                style={[
                  styles.cell2,
                  styles.headerCell,
                  styles.section3,
                  styles.tc,
                ]}
              >
                <Text>SESSION</Text>
              </View>
              <View
                style={[
                  styles.cell2,
                  styles.headerCell,
                  styles.section3,
                  styles.tc,
                ]}
              >
                <Text>TYPE</Text>
              </View>
              <View
                style={[
                  styles.cell7,
                  styles.headerCell,
                  styles.section3,
                  styles.tc,
                ]}
              >
                <Text> {localizedStrings.account.paymentno}</Text>
              </View>
              <View
                style={[
                  styles.cell8,
                  styles.headerCell,
                  styles.section3,
                  styles.tc,
                ]}
              >
                <Text>DESCRIPTION</Text>
              </View>
              <View
                style={[
                  styles.cell2,
                  styles.headerCell,
                  styles.section3,
                  styles.tc,
                ]}
              >
                <Text>MONTANT</Text>
              </View>
              {data &&
                data?.payments &&
                data?.payments?.map((ele, index) => (
                  <React.Fragment>
                    <View style={[styles.cell2, styles.tl]}>
                      <Text>
                        {moment(ele.ses_paymentdate).format("YYYY/MM/DD")}
                      </Text>
                    </View>
                    <View style={[styles.cell2, styles.tl]}>
                      <Text>{ele.ses_term}</Text>
                    </View>
                    <View style={[styles.cell2, styles.tl]}>
                      <Text>
                        {paymentOptionList(
                          ele[
                            "ses_paymenttype@OData.Community.Display.V1.FormattedValue"
                          ],
                          true,
                        )}
                      </Text>
                    </View>
                    <View style={[styles.cell7, styles.tl]}>
                      <Text>{ele.ses_paymentno}</Text>
                    </View>
                    <View style={[styles.cell8, styles.tl]}>
                      <Text>{ele.usb_portalnotes}</Text>
                    </View>
                    <View style={[styles.cell2, styles.tr]}>
                      <Text>{convertCurrencyFormat(ele.ses_paymentamt)}</Text>
                    </View>
                  </React.Fragment>
                ))}
              <View style={[styles.cell2, styles.tl]}>
                <Text>Total</Text>
              </View>
              <View style={[styles.cell2]}>
                <Text></Text>
              </View>
              <View style={[styles.cell2]}>
                <Text></Text>
              </View>
              <View style={[styles.cell7]}>
                <Text></Text>
              </View>
              <View style={[styles.cell8]}>
                <Text></Text>
              </View>

              <View style={[styles.cell2, styles.tr]}>
                <Text>{totalSumAmount(data.payments, "ses_paymentamt")}</Text>
              </View>
            </View>
          </View>
          {/* final part */}

          <View style={styles.row}>
            <View
              style={[
                styles.cellfooter,
                styles.headText,
                styles.font2,
                styles.mt1,
              ]}
            >
              <View style={[styles.container, { justifyContent: "flex-end" }]}>
                <View
                  style={[
                    styles.cell6,
                    styles.tc,
                    styles.headerCell,
                    styles.color1,
                  ]}
                >
                  <Text>Montant total dû</Text>
                </View>
              </View>
              <View style={[styles.container, { justifyContent: "flex-end" }]}>
                <View style={[styles.cell6, styles.tc]}>
                  <Text>{subtractValues(data.invoices, data.payments)}</Text>
                </View>
              </View>
            </View>
          </View>
        </Page>
      )}
    </Document>
  );
};

export default ARReport;
